import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';



const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  containerTF: {
     maxHeight:'29.6vh',
     marginTop:'20px'
   },
});

export default function StickyHeadTable(props) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  let rowsData    = []
  let columnsDataForAreaWise = []
  let rowsDataForAreaWise    = []
  

  // const columns = [
  //   { id: 'ULB', label: 'ULB', minWidth: 170 , align: 'center' },
  //   { id: 'Area', label: 'Area', minWidth: 100 , align: 'center'},
  //   {
  //     id: 'Count',
  //     label: 'Count',
  //     minWidth: 170,
  //     align: 'center',
  //     format: (value) => value.toLocaleString('en-US'),
  //   }
  // ];
  
  function createData(ULB, Area) {
    return {ULB, Area };
  }

  function createDataForTFWise(ULB,
  Area,
  Count) {
    return {ULB, Area,Count };
  }
  
  
  /*const rows = [
    createData('Trichy Corp','Sangliyandapuram',50),
    createData('Trichy Corp','E Pudur', 43),
    createData('Trichy Corp','KK Nagar', 60),
    createData('Trichy Corp','Crawford' , 43),
    createData('Trichy Corp','Airport', 39),
    createData('Trichy Corp','Kajamalai', 73),
    createData('Trichy Outer','Nagamangalam', 87),
    createData('Trichy Outer','Gundur', 76)
    
  ];*/

  props.rows.forEach(function(obj){
    let row = createData(obj.tfName,obj.LoadsCount)
    rowsData.push(row)
  })
  props.columnsDataHeaders.forEach(function(obj){
    let column =  { id: obj, label: obj, minWidth: 170 , align: 'center' }
    columnsDataForAreaWise.push(column)
  })

  props.TableDataBody.forEach(function(obj){
    let row = createDataForTFWise(obj.ULBName,obj.AreaName,obj.Count)
    rowsDataForAreaWise.push(row)
  })

  
  const rows    = rowsData
  const columnsForAreaWise = columnsDataForAreaWise
  const rowsForAreaWise    = rowsDataForAreaWise


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <div className="dashboard_new_listing">
  
  
  <Paper className={classes.root}>
      <TableContainer className={classes.containerTF}>
      <div style={{color:"rgb(102 102 102)", fontSize:"12px", fontWeight:"bolder",paddingTop:"10px",paddingBottom:"10px"}}>TF Wise Loads</div>
        <Table stickyHeader aria-label="sticky table">
        <TableHead>
            <TableRow>
            <TableCell align="center"style={{ minWidth: columnsForAreaWise.minWidth, fontWeight:'bolder', fontSize:"12px" }}>TF Name</TableCell>
            <TableCell align="center"style={{ minWidth: columnsForAreaWise.minWidth, fontWeight:'bolder', fontSize:"12px" }}>Load Count</TableCell>
            <TableCell align="center"style={{ minWidth: columnsForAreaWise.minWidth, fontWeight:'bolder', fontSize:"12px" }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row,rowIndex) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={rowIndex}>
                  {columnsForAreaWise.map((column,index) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={index} align={column.align} style={{fontSize:"12px"}}>
                        {column.format && typeof value === 'number' ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <TablePagination
        rowsPerPageOptions={[5,10, { label: '2', value: 2 }]}
        colSpan={3}
        count={rows.length}
        component="div"
        rowsPerPage={rowsPerPage}
        page={page}
        SelectProps={{
          inputProps: { 'aria-label': 'rows per page' },
          native: true,
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
      </TableContainer>
      
    </Paper>

            
    </div>
  );
}
